import { render, staticRenderFns } from "./zhiyuan_copy.vue?vue&type=template&id=4b1462b9&scoped=true"
import script from "./zhiyuan_copy.vue?vue&type=script&lang=js"
export * from "./zhiyuan_copy.vue?vue&type=script&lang=js"
import style0 from "./zhiyuan_copy.vue?vue&type=style&index=0&id=4b1462b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1462b9",
  null
  
)

export default component.exports